<template>
  <!-- 背景流星 -->
  <div id="stars">
    <div
      ref="star"
      class="star"
      v-for="(item, index) in star_num"
      :key="index"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Stars",
  data() {
    return {
      star_num: 4
    };
  },
  methods: {
    init_stars() {
      //   设置随机流星
      let star = this.$refs.star; //获取全部流星
      let mywidth = document.documentElement.clientWidth; //获取当前可视宽度
      let myheight = document.documentElement.clientHeight; //获取当前可视高度

      //初始化流星个数 和 left,top值
      star.forEach(e => {
        e.style.top = this.randomNumber(myheight * 0.3, -myheight * 0.2) + "px";
        e.style.left = this.randomNumber(mywidth * 1.3, 0) + "px";
      });

      // 给流星添加动画延时
      for (let i = 0, len = star.length; i < len; i++) {
        star[i].style.animationDelay = i % 6 == 0 ? "0s" : i * 0.8 + "s";
      }
    },

    //封装随机数函数
    randomNumber(max, min) {
      let randomnum = Math.floor(Math.random() * (max - min + 1) + min);
      return randomnum;
    }
  },
  mounted() {
    this.init_stars();
  }
};
</script>

<style scoped>
#stars {
  z-index: 2;
  margin: 0 auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 25% 10% 0 10%;
}
/*画出流星的形状*/
.star {
  display: block;
  opacity: 0;
  position: relative;
  left: 90%;
  width: 1px;
  background: transparent;
  /*流星动画*/
  -webkit-animation: star-fall 7s linear infinite;
  animation: star-fall 7s linear infinite;
  z-index: 9;
}
/*流星后面的尾巴*/
.star:after {
  content: " ";
  display: block;
  border: 1px solid #fff;
  border-width: 0px 50px 1px 80px;
  left: 3px;
  -webkit-transform: rotate(-20deg);
  transform: rotate(-20deg);
  border-color: transparent transparent transparent #eee;
}
/*创建动画，实现流星划过、渐入渐隐的效果*/
@-webkit-keyframes star-fall {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.5) translate3d(0, 0, 0);
    transform: scale(0.5) translate3d(0, 0, 0);
  }
  50% {
    opacity: 1;
    -webkit-transform: translate3d(-100px, 50px, 0);
    transform: translate3d(-100px, 50px, 0);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1.2) translate3d(-200px, 100px, 0);
    transform: scale(1.2) translate3d(-200px, 100px, 0);
  }
}
@keyframes star-fall {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.5) translate3d(0, 0, 0);
    transform: scale(0.5) translate3d(0, 0, 0);
  }
  50% {
    opacity: 1;
    -webkit-transform: translate3d(-100px, 50px, 0);
    transform: translate3d(-100px, 50px, 0);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1.2) translate3d(-200px, 100px, 0);
    transform: scale(1.2) translate3d(-200px, 100px, 0);
  }
}
</style>
